import React from 'react';
import '../../components/OurLocation/OurLocation.scss';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaPhoneAlt, FaUserAlt, FaGlobe } from 'react-icons/fa';

const OurLocation = [
  {
    title: "Head Office:DELHI",
    contactPerson: "Mr.Rohit Singh",
    address: "1/21 Gali No.1, Lalita Park, Laxmi Nagar, Delhi :110092",
    website: "www.carehealthhome.com",
    phones: ["+91-8447307473", "+91-9625436163"],
    directions: "https://www.google.com/maps/dir/28.5164634,77.3166364/3rd+Floor,+Care+Health+Nursing+Services+:-+Nursing+Bureau+in+Delhi+%7C+Nursing+Service+in+Delhi+%7C+24hrs+Patient+Caretaker+at+home+in+Delhi,+1%2F30,+opp.+Metro+Pillar+Number+24,+Lalita+Park,+Laxmi+Nagar,+New+Delhi,+Delhi+110092/@28.5706314,77.213807,12z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x390cfcad59bb9573:0x3f8e676c1ad855d3!2m2!1d77.27306!2d28.629167?entry=ttu&g_ep=EgoyMDI1MDEyNy4wIKXMDSoASAFQAw%3D%3D",
  },

  
  {
    title: " Branch: WEST DELHI",
    contactPerson: "Miss.Charu Gambhir",
    address: "1  A -13 Karampura , Near milan cinema Moti Nagar Delhi pincode - 110015 ",
    website: "www.carehealthhome.com",
    phones: ["+91-9910531897", "+91-9625436163"],
    directions: "#",
  },


  {
    title: "Branch: NOIDA",
    contactPerson: "Mr. Shivang Dwivedi",
    address: "BS-807, 8th Floor, Galaxy Diamond Plaza, Near Gaur City Mall, Gr. Noida West 201309",
    website: "www.carehealth24x7.in",
    phones: ["+91-9999407473", "+91-9999320665"],
    directions: "https://www.google.com/maps/dir/28.5164634,77.3166364/Care+Health+Nurses+Pvt+Ltd+:-Home+Care+Nursing%7C+Home+Care+Attendant%7C+ICU+Nurses+for+home+care%7CPatient+Care+Attendant,+Mall,+Bs-807+Diamond+Galaxy+plaza,+Near+Charmurti+Gaurcity,+opp.+Gaur,+Saundaryam+St,+Greater+Noida,+Uttar+Pradesh+201309/@28.593028,77.4166319,15.05z/data=!4m9!4m8!1m1!4e1!1m5!1m1!1s0x390cee59fafe065f:0x8a73583a50e14bdd!2m2!1d77.431963!2d28.6067013?entry=ttu&g_ep=EgoyMDI1MDEyNy4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    title: "Branch: GURGAON", 
    contactPerson: "Miss. Pallavi Prajapati",
    address: "1195, Near Out Gate Back Side Sahara Mall, Maruti Vihar, Gurgaon",
    website: "www.carehealth24x7.com",
    phones: ["+91-9205981026", "+91-8744809589"],
    directions: "https://www.google.com/maps/dir//Care+Health+Nurses+Pvt+Ltd+(+Gurgaon+):-+Nursing+Attendant+%7CPatient+Care+in+Gurgaon%7C+Home+Care+Nursing+Attendant%7CPatient+care,+Sahara+Mall,+1195,+Near+Out+Gate+Back+Side,+Maruti+Vihar,+Gurugram,+Haryana+122002/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x390d1921cc000001:0x67a8fc683dc86b0a?sa=X&ved=1t:57443&ictx=111",
  },
  {
    title: "Branch: GHAZIABAD",
    contactPerson: "Mr.Adarsh Shakya",
    address: "LGF-17, Rajhans Market, Ahinsa Khand - 1, Near Aditya Mall, Indirapuram, Ghaziabad",
    website: "www.carehealthathome.in",
    phones: ["+91-8447307473", "+91-9625436163"],
    directions: "https://www.google.com/maps/dir//LGF+17,+Care+Health+Nurses+Pvt.+Ltd.+:-+Home+Care+Nurses%2Fattendant+in+Indirapuram+%7CPatient+Care+taker+at+Home+Care+%7C+Wardboy+at+Home,+Rajhans+Plaza,+opposite+Aditya+Mall,+Ahinsa+Khand+1,+Indirapuram,+Ghaziabad,+Uttar+Pradesh+201014/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x390cfb53b893430b:0x7022ffc1ff7c952e?sa=X&ved=1t:57443&ictx=111",
  },
  {
    title: "Branch: KANPUR",
    contactPerson: "Mr.Vinay Singh",
    address: "84/226 Ac Afim Kothi, Hamirpur Road, Anwarganj,Kanpur,Up",
    website: "www.homecarekanpur.com",
    phones: ["+91-8881000186", "+91-9319337413"],
    directions: "https://www.google.com/maps?rlz=1C1ONGR_enIN1128IN1128&sca_esv=3e7026d05fa1ec3b&lqi=CiNjYXJlIGhlYWx0aCBudXJzaW5nIHNlcnZpY2VzIGthbnB1ckjvvtjW1riAgAhaQxAAEAEQAhADGAAYARgCGAMYBCIjY2FyZSBoZWFsdGggbnVyc2luZyBzZXJ2aWNlcyBrYW5wdXIqCggCEAAQARACEAOSARhob21lX2hlbHBfc2VydmljZV9hZ2VuY3mqAVcKCS9tLzAxX3E3aBABMh8QASIbsbAqhM5J4UnNga3lGlbJ781ab83U8VpG4PwyMicQAiIjY2FyZSBoZWFsdGggbnVyc2luZyBzZXJ2aWNlcyBrYW5wdXI&vet=12ahUKEwjMlom0_pyLAxWSUGwGHeV8HoMQ8UF6BAgFEFQ..i&lei=-DKbZ8y6JpKhseMP5fn5mAg&cs=1&um=1&ie=UTF-8&fb=1&gl=in&sa=X&geocode=KWUOunJkR5w5MTPvA-z9FHC4&daddr=84/226,+near+Keshav+Dwar+Gate,+near+Major+Salman+Bus+Stand,+Afim+Kothi,+Anwarganj,+Darshan+Purwa,+Kanpur,+Uttar+Pradesh+208003",
  },
  {
    title: "Branch : LUCKNOW",
    contactPerson: "Miss. Priyanka Naryal",
    address: "9A-Third Floor, Hera Plaza, Sector-8, Vikas Nagar , Lucknow, Up",
    website: "www.carehealthathome.in",
    phones: ["+91-9899478674", "+91-8081697878"],
    directions: "https://www.google.com/maps/dir//UGF-02,+Care+Health+Nursing+Services:-+Nursing+Bureau+in+Lucknow+%7C+Nursing+Agency+in+Lucknow+%7C+Elder+Care+in+Lucknow,+KDT+Plaza+Ram+Ram+Bank,+Sector+Q+Rd,+Aliganj,+Lucknow,+Uttar+Pradesh+226024/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x399957347ddeeead:0x8537790948054916?sa=X&ved=1t:57443&ictx=111",
  },
  {
    title: "Branch: INDORE",
    contactPerson: "Mr.Siddharth Singh",
    address: "14, MR-3, Mahalaxmi Nagar, Near Sun City Colony, Indore-452010",
    website: "www.ishaanhomehealth.com",
    phones: ["+91-9266331390", "+91-9266331385"],
    directions: "#",
  },
];

const animationVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const BranchOffices = () => {
  return (
    <div className="branch-offices">
      {OurLocation.map((office, index) => (
        <motion.div
          className="office-card"
          key={index}
          variants={animationVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >

          <h3>
            <FaMapMarkerAlt /> 
          {office.title}
          </h3>
          <hr />
          {office.contactPerson && (
            <p><FaUserAlt /> <strong>Contact Person:</strong> {office.contactPerson}</p>
          )}
          <p><FaMapMarkerAlt /> <strong>Address:</strong> {office.address}</p>
          {office.phones && (
            <p><FaPhoneAlt /> <strong>Phones:</strong> {office.phones.join(', ')}</p>
          )}
          {office.website && (
            <p><FaGlobe /> <strong>Website:</strong> <a href={`https://${office.website}`} target="_blank" rel="noopener noreferrer">{office.website}</a></p>
          )}
          <a href={office.directions || '#'} className="get-directions">Get Direction</a>
        </motion.div>
        
      ))}
    </div>

  );
  
};

export default BranchOffices;
